import React from 'react';
import { DrawerOverlay as ChakraDrawerOverlay, ModalOverlayProps as ChakraDrawerOverlayProps } from '@chakra-ui/react';

export function DrawerOverlay(props: ChakraDrawerOverlayProps) {
  return <ChakraDrawerOverlay {...props} />;
}
